import { useEffect } from 'react';

export default function useObjectMovement(
    canvasInstance,
    onMove) {


        
    useEffect(() => {
        if (!canvasInstance.current) return;

        const handleMove = (e) => {
            if (!e.target || !onMove) return;

            const imgObject = canvasInstance.current.getObjects().find(obj => obj.type === 'image')

            if (!imgObject) return;

            // 获取图片边界
            const imgLeft = imgObject.left;
            const imgTop = imgObject.top;
            const imgWidth = imgObject.width * imgObject.scaleX;
            const imgHeight = imgObject.height * imgObject.scaleY;

            const rectWidth = e.target.width * e.target.scaleX;
            const rectHeight = e.target.height * e.target.scaleY;

            // 计算移动边界
            let newLeft = e.target.left;
            let newTop = e.target.top;

            // 左
            newLeft = Math.max(imgLeft, newLeft);
            // 右
            newLeft = Math.min(imgLeft + imgWidth - rectWidth, newLeft);
            // 上
            newTop = Math.max(imgTop, newTop);
            // 下
            newTop = Math.min(imgTop + imgHeight - rectHeight, newTop);

            e.target.set({
                left: newLeft,
                top: newTop
            });

            canvasInstance.current.requestRenderAll();
        };

        canvasInstance.current.on('object:moving', handleMove);
        return () => {
            canvasInstance.current?.off('object:moving', handleMove);
        };
    }, [canvasInstance, onMove]);
}